import { useFloorMapPresenter } from '@Map/FloorMap/FloorMapPresenter';
import { observer } from 'mobx-react-lite';
import { StyleSheet, View } from 'react-native';

import { ElevatorTextButton } from './Components/ElevatorTextButton';

export const ElevatorPanelSmall = observer(function ElevatorPanelSmall() {
  const { reversedFloorsVM, goFloor, selectedFloorId } = useFloorMapPresenter();

  return (
    <View style={styles.wrapper}>
      {reversedFloorsVM.map((floor) => (
        <ElevatorTextButton
          key={floor.id}
          onPress={() => {
            goFloor(floor.id);
          }}
          label={floor.title}
          isCurrent={selectedFloorId.value === floor.id}
          textStyle={styles.elevatorText}
        />
      ))}
    </View>
  );
});

const styles = StyleSheet.create({
  wrapper: {
    height: '100%',
    width: '100%',
    justifyContent: 'flex-end',
  },
  elevatorText: {
    textAlign: 'left',
    fontSize: 18,
    letterSpacing: (20 * 3) / 100,
    marginVertical: 4,
    lineHeight: 24,
  },
});
